<template>
  <div id="main" class="app-main">
    <!--找客服-->
    <div v-if="this.showControl.moreGuide && openType != 'f2e'" class="main_tip_show"  @mouseover="show">
      <div class="padding-tb-25" style="cursor: pointer;">
        <img src="./images/slider/arrow-right.png" @click="hide"/>
      </div>
      <div class="main_tip_space"></div>
      <a  class="main_tip_text" :style="{
             'color': selectColor(this.showControl.inChat),
             'background-color':selectBgColor(this.showControl.inChat),
            }"  @click="contactService">
        <img v-if="selectColor(this.showControl.inChat)==='white'" src="./images/slider/customer-service-white.svg" class="main_tip_x"/>
        <img v-else="selectColor(this.showControl.inChat)==='white'" src="./images/slider/customer-service-black.svg" class="main_tip_x"/>
        <div>
          客服
        </div>
      </a>
      <div style="display: flex;flex-direction: column" v-if="user.id">
        <a  class="main_tip_text" :style="{
             'color': selectColor(this.showControl.showLinkInfo),
             'background-color':selectBgColor(this.showControl.showLinkInfo),
            }" @click="showLink">
          <img v-if="selectColor(this.showControl.showLinkInfo)==='white'" src="./images/slider/chat-white.svg" class="main_tip_x"/>
          <img v-else src="./images/slider/chat-black.svg" class="main_tip_x"/>
          <div>
            联系人
          </div>
        </a>
        <div v-if="this.showControl.showLinkInfo" >
          <CustomerCard  :onClose="hideLink" :showCard="this.showControl.showLinkInfo"></CustomerCard>
        </div>
        <a  class="main_tip_text" :style="{
             'color':  selectColor(this.showControl.showFeedback),
             'background-color':selectBgColor(this.showControl.showFeedback),
            }" @click="showFeed">
          <img v-if="selectColor(this.showControl.showFeedback)==='white'" src="./images/slider/feedback-white.svg" class="main_tip_x"/>
          <img v-else="selectColor(this.showControl.showFeedback)==='white'" src="./images/slider/feedback-black.svg" class="main_tip_x"/>
          反馈
        </a>
      </div>
    </div>
    <a  class="bg1" v-else-if="openType != 'f2e'" @click="show">
      <Icon  class="iconStyle"  :size="30" color="white" type="ios-arrow-left"></Icon>
    </a>


    <complaint-modal :fade='this.showControl.showFeedback' @change="hideFeed"></complaint-modal>
    <CouponModal/>
    <BlacklistModal/>
    <FeeConfirmGuide v-if="!isShowXiniyuan"/>
    <router-view></router-view>

    <chatPop v-if="this.showControl.inChat && openType !='f2e'" :chatPop="true" :onClose="hideContactService" ref="chatpop" openpage="main"></chatPop>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import CouponModal from "./components/coupon-modal"
import consultationModal from '@/components/consultation-modal';
import complaintModal from '@/components/customer-complaint';
import BlacklistModal from "@/components/blacklist-modal"
import FeeConfirmGuide from "@/components/fee-confirm-guide"
import CustomerCard from "@/components/customer-card"

import chatPop from './components/chat-pop.vue'
import util from "./libs/util"
import {decode, encrypt} from "@/libs/encrypt-and-decode";
import env from './config/config';

const showControl = {
  'moreGuide': true,
  'inChat':false,
  'showLinkInfo':false,
  'showFeedback':false,
}


let firstOpenflag = false
export default {
  components: {
    chatPop,
    CouponModal,
    complaintModal,
    consultationModal,
    BlacklistModal,
    CustomerCard,
    FeeConfirmGuide
  },
  data() {
    return {
      user:{
        id: Cookies.get("user") ? decode(Cookies.get("user")) : Cookies.get("user")
      },
      showControl,
      theme: this.$store.state.theme,
      isShowXiniyuan: Cookies.get('isVest') == 'true' ? true : false,
      moreGuide: true,
      openType:''
    };
  },
  mounted() {
    let that=this
    util.getCurrencySymbol('')
    setTimeout(() => {
      this.openType = this.$route.query.type
    }, 1000);
    setTimeout(() => {
      this.openType = this.$route.query.type
    }, 2000);
    setTimeout(() => {
      this.openType = this.$route.query.type
    }, 3000);
    that.showControl.moreGuide = window.localStorage.getItem('moreGuide')=='1'
    document.addEventListener('click', (e) => {
      if (!that.showControl.moreGuide) {
        that.showControl.inChat = false;
        that.showControl.showLinkInfo = false;
        that.showControl.showFeedback = false;
      }
    })
    if (location.href.includes('/excess')) {
      window.sessionStorage.setItem('redirectUrl', '/excess')
    }
    if (location.href.includes('/peakSeasonQuota')) {
      window.sessionStorage.setItem('redirectUrl', '/peakSeasonQuota')
    }
    if (location.href.includes('/place-order/pre')) {
      window.sessionStorage.setItem('redirectUrl', '/place-order/pre')
    }
    if (location.href.includes('/confirm-box/index')) {
      window.sessionStorage.setItem('redirectUrl', '/confirm-box/index')
    }
    if (this.getUrlKey('haiyunFlag')) {
      window.sessionStorage.setItem('haiyunFlag', this.getUrlKey('haiyunFlag'))
    }
    if (this.getUrlKey('haiyunOpenId')) {
      window.sessionStorage.setItem('haiyunOpenId', this.getUrlKey('haiyunOpenId'))
    }
    let language = (navigator.browserLanguage || navigator.language).toLowerCase();
    if (!(window.location.search || window.sessionStorage.getItem('entozh'))) {
      if (language != 'zh-cn' && language !== 'zh' && language != 'ja' && language != 'ja-JP') {
        window.location.href = "https://en.duckbillscm.com";
        window.sessionStorage.setItem('entozh', true);
      }
    }
    console.log("window.env====",env.env);
    if (env.env == 'development') {
      window.env = {
        upload: 'http://uploadfile.fat.driverglobe.com',
        message: 'https://api.fat.driverglobe.com/message-center'
      }
    } else {
      window.env = {
        upload: 'https://upload.carrierglobe.com',
        message: 'https://new.carrierglobe.com/gw/message-center'
      }
    }

    this.$store.dispatch("data/savePortList")
  },
  methods: {
    baiduTongji(name) {
      try{
        _hmt.push(['_trackEvent', 'PC-APPVUE页面', 'PC-APPVUE页面-' + name, Cookies.get("userId") ? `企业名：${Cookies.get('companyName')} 用户名:${Cookies.get('userId')}` : '未登录'])
      }catch (e){
        console.log("APPVUE统计时报错")
      }
    },
    checkShow(){
      let canShow = true;
      Object.keys(this.showControl).forEach((showKey)=>{
        if(showKey!="moreGuide"){
          this.showControl[showKey] = false;
        }
      });
      this.showControl.inChat = false;
      console.log("canShow===",canShow)
      return canShow
    },
    hide() {
      window.localStorage.setItem('moreGuide', '0')
      this.showControl.moreGuide = false
      this.baiduTongji("关闭侧边栏联系卡")
    },
    show() {
      window.localStorage.setItem('moreGuide', '1')
      this.showControl.moreGuide = true
      this.baiduTongji("点开侧边栏联系卡")
    },

    hideLink() {
      this.showControl.showLinkInfo = false
    },
    showLink() {
      if(!this.checkShow()){
        return;
      }
      this.showControl.showLinkInfo = true
      this.baiduTongji("点击查看联系人卡片")
    },

    selectColor(select){
      return select?'white':'black';
    },

    selectBgColor(select){
      return select?'#02cad6':'white';
    },

    showFeed(){
      if(!this.checkShow()){
        return;
      }
      this.baiduTongji("点击投诉与反馈")
      this.showControl.showFeedback = true
    },
    hideFeed(){
      this.showControl.showFeedback = false
    },

    getUrlKey: function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null
    },

    hideContactService(){
      this.showControl.inChat = false;
    },
    contactService() {
      if(!this.checkShow()){
        return;
      }
      this.showControl.inChat = true;
      setTimeout(() => {
        this.$refs.chatpop.judgeUser();
      }, 100);
      this.baiduTongji("点击联系客服")
    },
  },

  watch: {
    '$route.name': function (v) {
      if ( !this.user.id) {
        this.showControl.moreGuide = true
      } else {
        this.showControl.moreGuide =  false
      }
    }
  },

};
</script>

<style>
.app-main {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.main_tip_show {
  z-index: 9999;
  position: absolute;
  right: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  top: 25%;
  width: 91px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
}

.main_tip_x {
  color: black;
  padding:10px;
  width: 50px;
}

.padding-tb-25 {
  padding-top: 25px;
  padding-bottom: 25px;
}

.main_tip_text {
  /*  border-left: 1px solid grey;
    border-right: 1px solid grey;*/
  text-align: center;
  color: black;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  width: 88px;
  padding: 16px;
}


.bg1 {
  z-index: 9999;
  position: absolute;
  right: 0px;
  top: 30%;
  width: 40px;
  height: 80px;
  border-radius: 120px 0 0 120px;
  background-color: #02cad6;
  justify-content: center;
  align-items: center;
  align-content: center;
  text-align: center;
}

.main_tip_space{
  width: 60px;
  background-color: #bfbfbf;
  opacity: 0.4;
  height: 0.5px;
}

.iconStyle {
  width: 30px;
  height: 30px;
  text-align: center;
  justify-self: center;
  justify-content: center;
  margin-top: 25px;
}
</style>






// WEBPACK FOOTER //
// App.vue?5aa3f87a